import * as S from "../../Style/Page/Car.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitleCar.js";
// const Mapimg = `${process.env.REACT_APP_ASSET_BASE || ""}/static/media/01. 자동차사업 국내지도.a126c83fa548a13f53a9.png`;
import Carimg from "../../assets/CarBusiness/car.png";
import Mapimg from "../../assets/CarBusiness/자동차사업 국내지도.png";
import HatPageTopLine from "../../Component/CarPageTopLine.js";
const Introduce = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"자동차판매사업"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <div className="kor">자동차사업</div>
              <div className="eng">Car Business</div>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">Fork Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"320px"}>
            <S.NavItem>
              <Link to="/CarBusiness/introduce">
                <div className="kor">자동차사업</div>
                <div className="eng">Car Business</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/Sales">
                  <div className="kor">자동차 판매사업</div>
                  <div className="eng">Automotive Sales Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/AsService">
                  <div className="kor">AS정비사업</div>
                  <div className="eng">AS maintenance business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/RentalService">
                  <div className="kor">렌터카 사업</div>
                  <div className="eng">Vehicle Rental Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/AsParts">
                  <div className="kor">A/S 부품 사업</div>
                  <div className="eng">After-Sales (A/S) Parts Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/CarBusinessHistory">
                  <div className="kor">자동차사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>
        <div className="wrap">
          <div className="inner">
            <PageTitle titleko={"사업개요"} titleeng={"Automobile sale Business"} website={"http://www.dm.co.kr/"} />
            <div className="page-text car-introduce">
              <div className="kor">
                1993년 대우자동차㈜로부터 영업부문을 분리, 대우자동차판매㈜가
                설립되었고 2012년 영안 계열사로 편입되었습니다. 영안은 2012년
                대우자동차판매(주)를 인수하여 버스 판매사업과 자동차 정비사업,
                렌터카사업 등을 진행해 왔습니다. 2025년 르노 승용차, 2026년 한국지엠 캐딜락 & GMC 승용차를 
판매하고 있습니다. 
자동차 정비사업은 1993년부터 현재까지 승용차, 버스, 트럭, 수입차 등 토털 정비가 
가능한 대형 정비사업소 네트워크 11개소를 전국에 보유하고 있습니다. 렌터카 사업은 전국 7개 엉업소를 
국산차 및 수입차 500여대를 운영하고 있습니다. 국내 버스 판매사업은 2022년 7월 국내 버스공장 생산 
중단으로 2024년 4월 부터는 중단하게 되었습니다.
              </div>
              <div className="eng">
                In 1993, the sales division was separated from Daewoo Motor Co., Ltd. to establish Daewoo 
Motor Sales Co., Ltd., which became an affiliate of YoungAn in 2012. Following the acquisition of 
Daewoo Motor Sales Co., Ltd. in 2012, YoungAn has been conducting operations including the 
bus sales business, automotive maintenance business, and vehicle rental business. The Compa
ny has been selling Renault passenger vehicles since 2025 and GM Korea's Cadillac & GMC 
passenger vehicles since 2026. For the automotive maintenance business, the Company oper
ates a nationwide network of 11 large-scale service centers established since 1993, providing 
total maintenance services for passenger vehicles, buses, trucks, and imported vehicles. The 
vehicle rental business operates a fleet of over 500 domestic and imported vehicles through 7 
branch offices nationwide. The domestic bus sales business was discontinued from April 2024 
due to the suspension of production at the domestic bus factory in July 2022.
              </div>
              <div className="car-introduce-image">
                <img src={Carimg} className="hat-img" alt="자동차 판매 차량" />
              </div>
            </div>

            <PageTitle titleko={"사업자 현황"} titleeng={"Business Status"} />
            <div className="page-text">
              <div className="kor">
                <strong>자동차 판매</strong>
                <br />
                1)  르노 승용차 판매사업으로 전국에 7개 전시장을 운영하고 있습니다 (르노 부품판매 병행)
                <br />
                2) 캐딜락 & GMC 승용차 판매사업으로 부산에 전시장을 운영하고 있습니다.
                <br />
                <br />

                <strong>A/S 정비사업</strong>
                <br />
                승용차, 버스, 트럭, 수입차 등 토털 정비 가능한 전국 11곳 직영 정비사업소를 보유하고 있습니다.
                <br />
                정비처리 능력은 연간 23만대 입니다.
                <br />
                <br />
                <strong>렌터카 사업</strong>
                <br />
                본사 및 7개 영업소로 국산차 및 수입차 500여대를 운영하고 있습니다.
                <br />
                <br />
                <strong>A/S 부품 사업</strong>
                <br />
                한국에서 운행중인 약 2만여대 자일대우버스 부품 공급을 위해 전국 55개 대리점을 운영하고 있습니다.
                <br />
                <br />
                
              </div>
              <div className="eng">
                <strong>A/S Maintenance Operations</strong>
                <br />
                We own and operate 12 directly-managed maintenance facilities nationwide capable of
                total maintenance for passenger cars, buses, trucks, and imported vehicles.
                <br />
                Our maintenance processing capacity is approximately 230,000 units annually.
                <br />
                <br />
                <strong>Car Rental Business</strong>
                <br />
                We operate approximately 500 domestic and imported vehicles through our headquarters and 7 branches.
                <br />
                <br />
                <strong>A/S Parts Business</strong>
                <br />
                To supply parts for around 25,000 Daewoo buses in operation in Korea,
                <br />
                we operate 54 dealerships nationwide.
                <br />
                <br />
                <strong>Automotive sales</strong>
                <br />
                Since the establishment of the sales company in 1993 up to now the company has been engaged in 
                <br />
                the sales cars and Commercial bus
              </div>
              
            </div>
            <img className="fullsize-map" src={Mapimg} alt="" />
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default Introduce;
